/**
 * @module compareImages
 * Enhanced image comparison module with improved responsive behavior
 */

module.exports = function() {
    const overlayElements = document.querySelectorAll( '.img-comp-overlay' );

    overlayElements.forEach( ( img ) => compareImages( img ) );

    function compareImages( img ) {
        let clicked = 0;
        let initialWidth, initialHeight;

        const updateDimensions = () => {
            const container = img.parentElement;
            initialWidth = container.offsetWidth;
            initialHeight = container.offsetHeight;

            img.style.width = ( initialWidth / 2 ) + 'px';
        };

        updateDimensions();

        const slider = document.createElement( 'DIV' );
        slider.setAttribute( 'class', 'img-comp-slider' );

        img.parentElement.insertBefore( slider, img );

        const positionSlider = () => {
            slider.style.top = 0;
            slider.style.height = `${ initialHeight }px`;
            slider.style.left = ( img.offsetWidth - ( slider.offsetWidth / 2 ) ) + 'px';
        };

        positionSlider();

        slider.addEventListener( 'mousedown', slideReady, { passive: false } );
        slider.addEventListener( 'touchstart', slideReady, { passive: false } );

        window.addEventListener( 'mouseup', slideFinish );
        window.addEventListener( 'touchend', slideFinish );

        window.addEventListener( 'resize', () => {
            updateDimensions();
            const currentPercentage = img.offsetWidth / initialWidth;
            img.style.width = ( initialWidth * currentPercentage ) + 'px';
            positionSlider();
        } );

        function slideReady( e ) {
            e.preventDefault();
            e.stopPropagation();

            clicked = 1;

            window.addEventListener( 'mousemove', slideMove, { passive: false } );
            window.addEventListener( 'touchmove', slideMove, { passive: false } );
        }

        function slideFinish() {
            if ( clicked === 0 ) {
                return;
            }

            clicked = 0;

            window.removeEventListener( 'mousemove', slideMove );
            window.removeEventListener( 'touchmove', slideMove );
        }

        function slideMove( e ) {
            if ( clicked === 0 ) {
                return false;
            }

            e.preventDefault();
            e.stopPropagation();

            const pos = getCursorPos( e );

            const boundedPos = Math.max( 0, Math.min( pos, initialWidth ) );

            slide( boundedPos );
        }

        function getCursorPos( e ) {
            const containerRect = img.parentElement.getBoundingClientRect();
            let x;

            if ( e.type.includes( 'touch' ) ) {
                x = e.touches[ 0 ].clientX;
            } else {
                x = e.clientX;
            }

            return x - containerRect.left;
        }

        function slide( x ) {
            img.style.width = x + 'px';

            slider.style.left = ( x - ( slider.offsetWidth / 2 ) ) + 'px';
        }
    }
};
